const accounts = String(process.env.VUE_APP_ACCOUNTS_PREFIX).replace("/", "");
const ACCOUNT_HOST = process.env.VUE_APP_API_HOST + process.env.VUE_APP_ACCOUNTS_PREFIX.replace("/", "");
const ORGANIZATION_HOST = process.env.VUE_APP_API_HOST + process.env.VUE_APP_ORGANIZATION_PREFIX.replace("/", "");
const PASS_ORDER_HOST = process.env.VUE_APP_API_HOST + process.env.VUE_APP_PASS_ORDER_PREFIX.replace("/", "");
const PLACES_HOST = process.env.VUE_APP_API_HOST + process.env.VUE_APP_PLACES_PREFIX.replace("/", "");
const ACCOUNTS_INSTANCE = String(process.env.VUE_APP_ACCOUNTS_PREFIX).replace("/", "");
const ORGANIZATION_INSTANCE = String(process.env.VUE_APP_ORGANIZATION_PREFIX).replace("/", "");
const PASS_ORDER_INSTANCE = String(process.env.VUE_APP_PASS_ORDER_PREFIX).replace("/", "");
const PLACES_INSTANCE = String(process.env.VUE_APP_PLACES_PREFIX).replace("/", "");
const SOCKET_BASE_HOST = String(process.env.VUE_APP_SOCKET_BASE_HOST)
const EVENTCHAIN_HOST = process.env.VUE_APP_API_HOST + process.env.VUE_APP_EVENTCHAIN_PREFIX.replace('/', '')
const EVENTCHAIN_INSTANCE = String(process.env.VUE_APP_EVENTCHAIN_PREFIX).replace('/', '')

export {
    ACCOUNT_HOST,
    ACCOUNTS_INSTANCE,
    ORGANIZATION_HOST,
    ORGANIZATION_INSTANCE,
    PASS_ORDER_HOST,
    PASS_ORDER_INSTANCE,
    PLACES_INSTANCE,
    PLACES_HOST,
    SOCKET_BASE_HOST,
    EVENTCHAIN_HOST,
    EVENTCHAIN_INSTANCE
}
export default {
    accounts
}
